import React, { useState } from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { Menu, MenuItem, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import './header.css';
import { useSelector } from "react-redux";
import store from "../../Redux/store";
import { menuByUserType } from "../../constants/headerMenu";
import { clearOrderDetails } from "../../Redux/Slices/customerSlice";
import CustomPopupForm from "../../component/customPopupModel";


export default function ProfileMenu({ anchorEl, open, handleClose }) {
  const [openLogout, setOpenLogout] = useState(false);
  const navigate = useNavigate();
  const { loginDetails } = useSelector((state) => state.counter);
  const menuOptions = [
    ...(menuByUserType[loginDetails.userType] || []),
    { label: "Logout", route: "", icon: <FaSignOutAlt size={18} /> }
  ];

  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 6,
          className: 'custom-menu-paper',
          style: {
            borderRadius: 16,
            minWidth: 220,
            boxShadow: "0 2px 18px 4px #008ecc22",
            paddingTop: 6,
            paddingBottom: 6,
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          style: {
            padding: 0,
          }
        }}
      >
        {menuOptions.map(({ label, icon, route }, idx) => (
          <div key={label}>
            <MenuItem
              onClick={() => {
                handleClose();
                if (loginDetails.userType === "normal user") {
                  clearOrderDetails()
                }
                if (label === "Logout") {
                  setOpenLogout(true)
                  // store.dispatch({ type: 'RESET_STORE' });
                  // navigate("/");
                } else {
                  navigate(route);
                }
              }}
              className="custom-menu-item"
              style={{
                padding: "12px 22px",
                borderRadius: 10,
                display: "flex",
                alignItems: "center",
                gap: 12,
                fontSize: 15,
                color: label === "Logout" ? "#e55353" : "#244457",
                fontWeight: label === "Logout" ? 500 : 600,
                cursor: "pointer",
                background: "none"
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: label === "Logout" ? "#e55353" : "#3383b2",
                  fontSize: 21,
                  marginRight: 12
                }}
                className="menu-icon"
              >
                {icon}
              </span>
              <span className="menu-label">{label}</span>
            </MenuItem>
            {idx < menuOptions.length - 1 && (
              <Divider
                style={{
                  margin: "0 16px",
                  background: "#e7f0fa"
                }}
              />
            )}
          </div>
        ))}
      </Menu>
      <CustomPopupForm
        isOpen={openLogout}
        handleClose={() => setOpenLogout(false)}
        dialogType="logout"
      />
    </div>
  );
}


